import { Component, Input, OnInit, ViewChild, Host, EventEmitter, Output, Optional, ContentChildren, QueryList, Injector } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { EasyFormComponent } from '../form/form.component';
import { FMSUtilityService } from '../../services/utility/utility.service';
import { FormGroupComponent } from '../form-group/form-group.component';
import { ChildParentTalk, IErrorHandler } from '../../data-models/child-parent-talk';
import { FormErrorComponent } from '../error/error.component';
import { LocalizePipe } from '../../../../pipes/Localize.pipe';

const A_Small: number = 97;
const Z_Small: number = 122;

const A_Capital: number = 65;
const Z_Capital: number = 90;

export abstract class BaseInputComponent extends ChildParentTalk {

    @Input() label: string;
    @Input() name: string;
    @Input() id: string;
    @Input() error: string;
    @Input() placeholder: string;
    @Input() tooltip: string;
    @Input() maxLength: number;
    @Output() onChanges: EventEmitter<any> = new EventEmitter<any>();

    @Input() formControl: AbstractControl;
    @Input() text: string;

    labelClass: string = 'col-md-2';
    modelClass: string = 'col-md-8';
    required: boolean = false;
    loadingComplete: boolean = false;

    get isHidden() { return this.formControl && (this.formControl.valid || this.formControl.pristine) };
    get isError() { return this.formControlError; }

    get formControlError() {
        return this.formControl && !this.formControl.pristine && this.formControl.errors;
    }

    get requiredError() {
        return this.formControl && !this.formControl.pristine && this.formControl.errors && this.formControl.errors.required;
    }

    modelChanged(val) {
        //console.log(val);
    }

    parentForm: EasyFormComponent;
    parentFormGroup: FormGroupComponent;

    @Output()
    formModelChange = new EventEmitter();
    @Input()
    formModel: any;

    @ContentChildren(FormErrorComponent) errors: QueryList<FormErrorComponent>;

    ch($ev) {
        this.formModelChange.emit($ev);
    }

    private localize: LocalizePipe;
    constructor(@Host() parentForm: EasyFormComponent, @Optional() @Host() parentFormGroup: FormGroupComponent, protected injector: Injector) {
        super(injector);
        this.parentForm = parentForm;
        this.parentFormGroup = parentFormGroup;

        this.localize = this.injector.get(LocalizePipe);
    }

    abstract childOnInit();

    ngOnInit() {
        this.childOnInit();
        if (!this.name) {
            throw new TypeError("You must specify a [name] for any form member");
        }

        this.name = this.name.trim();
        this.label = this.label || this.convertNameToLabel();
        this.placeholder = this.placeholder || this.label;
        this.type = this.type || "text";
        this.error = this.error || "invalid input";
        this.id = this.id || Math.random().toString();
        this.maxLength = this.maxLength || null;

        this.tellYourParents();

        this.width = this.width || "2,8";
        this.inputWidth = this.inputWidth || 4;
        this.parseWidth();
        this.changeTextWithLocalization();

        if (this.isInline) {
            this.labelClass = '';
            this.modelClass = '';
        }

        if (this.findFormControl()) {
            this.formControl.valueChanges.subscribe(x => {
                this.onChanges.emit(x);
            });
        }

        setTimeout(() => this.loadingComplete = true, 1000);
    }

    findFormControl(): boolean {
        if (this.formControl) return true;

        if (!this.parentForm || !this.parentForm.formGroup) {
            console.warn("Can't find [FormGroup], name = " + this.name);
            return false;
        }

        var controls = this.parentForm.formGroup.controls;
        if (!controls || !controls[this.name]) {
            //console.log(this.parentForm.formGroup.controls)
            console.warn("Can't find [FormControl], name = " + this.name);
            return false;
        }

        this.formControl = controls[this.name];
        return true;
    }

    changeTextWithLocalization() {
        this.text = this.text || "";
        if (this.text.endsWith("*")) {
            this.required = true;
            this.text = this.text.substr(0, this.text.length - 1);
        }

        if (this.localizationSource) {
            this.text = this.text && this.localize.transform(this.text, this.localizationSource);
        } else {
            this.text = this.text && this.localize.transform(this.text);
        }
    }

    ngAfterViewInit() {
        this.errors.forEach(e => {
            e.formControl = this.formControl;
        });
    }

    parseWidth() {
        let splt = this.width.split(',');
        let left = +splt[0];
        let right = +splt[1];
        let offset = 0;

        if (splt.length == 3) {
            offset = +splt[0];
            left = +splt[1];
            right = +splt[2];
        }

        if (isNaN(left)) left = 12 - right;
        if (isNaN(right)) right = 12 - left;


        this.labelClass = left < 0 ? "" : "col-md-" + left;
        this.modelClass = right < 0 ? "" : "col-md-" + right;
        if (offset > 0)
            this.labelClass += " col-md-offset-" + offset;
    }

    convertNameToLabel(): string {
        let name = this.name;
        let label = name.charAt(0).toUpperCase();

        for (let i = 1; i < name.length; i++) {
            let c = name.charCodeAt(i);

            if (c >= A_Capital && c <= Z_Capital) {
                label += ' ';
            }

            label += name[i];
        }

        return label;
    }

    tellYourParents() {
        this.parentFormGroup && this.parentFormGroup.takeChild(this);
        this.parentForm && this.parentForm.takeChild(this);
    }

    takeChild(child: ChildParentTalk) {

        super.takeChild(child);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/base-input/base-input.component.ts